import React, { useState, useEffect } from "react";
import axios from "axios";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Loader from "../../components/Loader";
import {
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  DialogContentText,
} from "@material-ui/core";
import Card from "../../components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import AddIcon from "@material-ui/icons/Add";
import { getApi, postApi } from "../../services/api";
import {
  FARMERS,
  ASSIGN_FARMER_TO_RAKE_TEAM,
  ASSIGNABLE_FARMER_TO_SUB_TEAM,
  ASSIGN_FARMER_TO_BAILER_TEAM,
  ASSIGNED_FARMER_TO_SUB_TEAM,
  VEHICLE,
  USERS,
  EQUIPMENT,
  REASSIGN_SUB_TEAM,
  EQUIPMENT_TYPE as EQUIPMENT_TYPE_URL,
  SUB_DISTRICTS,
  TASKS,
  DISTRICTS,
  ASSIGN_FARM_TO_SUB_TEAM,
  GET_FARMS,
} from "../../configs/urls";
import { API_BASE_URL, ROLES as USER_ROLES } from "../../configs/constant";
import { withStyles } from "@material-ui/core/styles";

import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import EditIcon from "@material-ui/icons/Edit";
import { Multiselect } from "multiselect-react-dropdown";
import { DATE_FORMATS } from "../../configs/constant";
import * as moment from "moment";
import AddDistrictPopUp from "./AddDistrictPopUp";

import "./style.css";

import {
  Button,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import { EditRounded } from "@material-ui/icons";
import { DatePicker } from "@material-ui/pickers";
import {
  updateCropHarvestDate,
  updateSequenceInFarmer,
} from "constant/network";
import { useAtom } from "jotai";
import { sectorOfficerTeamDetails } from "store/store";

const JOB_STATUS = { PENDING: "pending", COMPLETE: "completed" };
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    minWidth: "100%",
  },

  jobOverview: {
    margin: "1% auto",
    fontWeight: "500",
    width: "100%",
    borderRadius: "3px",
  },
}));

const navBarStyles = makeStyles(styles);

export default function ViewSubTeam({
  team = {},
  projectList = [],
  teamParams = {},
  selectedTeam,
  sectorOfficerList = [],
  handleProjectChange = () => {},
  handleSectorOfficerChange = () => {},
  handleTeamChange = () => {},
  teams = [],
  callBackFunction = () => {},
}) {
  const [subTeamsList, setSubTeamsList] = useState([]);
  const [farmersList, setFarmersList] = useState([]);
  const [farmersListToShow, setFarmersListToShow] = useState([]);
  const [isRequesting, setIsRequesting] = useState(false);
  const [actionFor, setActionFor] = useState("");
  const classes = useStyles();
  // const teamTypes = Object.keys(subTeamDataForUpdate.sub_teams);
  const navBarClasses = navBarStyles();
  const { sub_teams = [] } = team;
  const [open, setFarmersAssignModal] = React.useState(false);
  const [viewDialogOpen, setViewDialogOpen] = React.useState(false);
  const [isDialogBoxOpen, setIsDialogBoxOpen] = useState(false);
  const [selectedFarmers, setSelectedFarmers] = useState([]);
  const [changeReason, setChangeReason] = useState([]);
  const [selectableListForEdit, setSelectableListForEdit] = useState([]);
  const [editedSubTeam, setEditedSubTeam] = useState({});
  const [editedEntity, setEditedEntity] = useState(null);
  const [editedEntityType, setEditedEntityType] = useState("");
  const [equipmentTypes, setEquipmentTypeList] = useState([]);
  // const [selectedEntity, setSelectedEntity] = useState();
  const [params, setParams] = useState({ page: 0 });
  const [selectedEntity, setSelectedEntity] = useState();

  const [vehiclesList, setVehiclesList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [helperList, setHelperList] = useState([]);
  const [equipementList, setEquipementList] = useState([]);
  const [editedTeamType, setEditedTeamType] = useState("");
  const [villageList, setVillagesList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);
  const [selectedVillage, setSelectedVillage] = useState("");
  const [selectedSubDistrict, setSelectedSubDistrict] = useState("");
  const [equipmentsData, setEquipmentsData] = useState([]);
  const [equipmentsListToShow, setEquipmentsListToShow] = useState([]);
  const [addDistrictPopupOpen, setAddDistrictPopupOpen] = useState(false);

  const [districtsList, setDistrictsList] = useState([]);
  const [openHarvestDateEditModal, setOpenHarvestDateEditModal] = useState(
    false
  );
  const [farmerId, setFarmerId] = useState();
  const [originalHarvestDate, setOriginalHarvestDate] = useState("");
  const [value, setValue] = useState("");
  const [updateSequence, setUpdateSequence] = useState({
    farm_id: 0,
    sequence: "",
  });
  const [filteredFarmer, setFilteredFarmer] = useState([]);

  const [pendingJobsFilter, setPendingJobsFilter] = useState();

  const filterAcToAssigned = () => {
    setFilteredFarmer([]);
    if (pendingJobsFilter && pendingJobsFilter == 20) {
      return farmersListToShow
        ?.filter((item) => item?.status !== null)
        .map((items) => {
          setFilteredFarmer((el) => [...el, items]);
        });
    } else if (pendingJobsFilter && pendingJobsFilter == 10) {
      return farmersListToShow
        ?.filter((item) => item?.status === null)
        .map((items) => {
          setFilteredFarmer((el) => [...el, items]);
        });
    }
    renderPendingJobs(filteredFarmer, 1);
  };

  useEffect(() => {
    filterAcToAssigned();
  }, [pendingJobsFilter]);

  const [teamDetails] = useAtom(sectorOfficerTeamDetails);
  const [teamId, setTeamId] = useState();
  const [sectorOfficerTeamData, setsectorOfficerTeamData] = useState();

  // useEffect(() => {
  //   if (teamId) {
  //     return localStorage?.setItem("teamId", teamId);
  //   }
  // }, [teamId]);

  const checkForDistrict = () => {
    return teamDetails?.data
      ?.filter((item) => item?.id === teamId)
      ?.map((item) => {
        setsectorOfficerTeamData(item);
      });
  };

  useEffect(() => {
    if (teamId && teamDetails) {
      return checkForDistrict();
    }
  }, [teamDetails, teamId]);

  const updateHarvestDateAPI = async () => {
    await axios
      .post(`${API_BASE_URL}${updateCropHarvestDate}`, {
        id: farmerId,
        crop_harvest_date: moment(value)?.format("YYYY-MM-DD"),
      })
      .then((res) => {
        setOpenHarvestDateEditModal(false);
      })
      .catch((err) => {
        setOpenHarvestDateEditModal(false);
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (value) {
      updateHarvestDateAPI();
    }
  }, [value]);

  const editHarvestDate = () => {
    setOpenHarvestDateEditModal(true);
  };

  const handleCloseEditHarvestDate = () => {
    setOpenHarvestDateEditModal(false);
  };

  /**
   * @description Fetching equipment list
   */
  useEffect(() => {
    axios.get(`${API_BASE_URL}/equipment`).then(({ data = [] }) => {
      const types = data.map(({ type = {}, equipment_type }) => {
        return {
          ...type,
          driver_id: "",
          equipment_id: type.id,
          vehicle_id: "",
          equipmentType: equipment_type,
        };
      });
      setEquipmentsData(data);
      setEquipmentsListToShow(types);
    });
  }, []);

  useEffect(() => {
    let district_ids = [];
    resetSelection();
    if (team?.team_village || team?.village) {
      // debugger;
      const { village, team_village } = team;
      const teamVillage = team_village.map((item) => item.village);
      setVillagesList(teamVillage);
      if (teamVillage && teamVillage.length > 0) {
        district_ids = teamVillage.map(
          (villageItem) => villageItem.district_id
        );
      } else {
        village?.district_id && district_ids.push(village.district_id);
      }
      getSubDistrict(
        district_ids,
        teamVillage && teamVillage.length ? teamVillage : [village]
      );
      getFarm();
    }
    if (team) {
      fetchEquipmentTypes(true);
      getDistrict();
    }
  }, [team]);
  // useEffect(()=>{
  //   if(teamParams?.project_id){
  //     const selectedProject=projectList.get(projectItem=>projectItem.id===teamParams.project_id)
  //   }
  // },[teamParams])
  const getDistrict = () => {
    setIsRequesting(true);

    getApi(DISTRICTS, { state_id: 1 })
      .then(
        (res) => {
          setDistrictsList(res.data || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };
  const getSubDistrict = (value, villageList) => {
    let district_id = "";
    if (value) {
      district_id = value;
    }

    setIsRequesting(true);

    getApi(SUB_DISTRICTS, { district_id })
      .then(
        (res) => {
          if (villageList) {
            let fileteredSubDis = res.data.filter((item) =>
              villageList.some(
                (villageItem) => villageItem.sub_district_id === item.id
              )
            );
            setSubDistrictList(fileteredSubDis || []);
          } else {
            setSubDistrictList(res?.data || []);
          }
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };
  const fetchEquipmentTypes = (isInitialLoad) => {
    setIsRequesting(true);

    getApi(EQUIPMENT_TYPE_URL, params)
      .then(
        (res) => {
          // if (isInitialLoad) setTotalequipmentCount(res.meta.total);

          const data = res.data || [];
          const newList = [...data];
          setEquipmentTypeList(newList || []);
        },
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };
  useEffect(() => {
    const subTeamsList = {};
    const subTeamsWithReady = sub_teams.filter(
      (subTeam) => subTeam.farmer_team_type_status !== JOB_STATUS.COMPLETE
    );
    sub_teams.map((team) => {
      const teamType = team?.team_type?.toLowerCase();
      if (teamType) {
        if (!subTeamsList[teamType]) {
          subTeamsList[teamType] = [team];
        } else {
          subTeamsList[teamType].push(team);
        }
      }
    });
    setSubTeamsList(subTeamsList);

    getAllData();
  }, [equipmentTypes]);
  const getAllData = () => {
    setIsRequesting(true);
    const getVehicles = getApi(VEHICLE, { district_id: 1 });
    const getDrivers = getApi(USERS, { role: USER_ROLES.DRIVER });
    const getHelpers = getApi(USERS, { role: USER_ROLES.HELPER });
    const equipments = getApi(EQUIPMENT);
    const getTasks = getApi(TASKS);

    axios
      .all([getVehicles, getDrivers, equipments, getHelpers, getTasks])
      .then((res) => {
        if (res[0] && res[0].data) {
          setVehiclesList(res?.[0]?.data || []);
        }

        if (res[1] && res[1].data) {
          setDriverList(res?.[1]?.data || []);
        }

        if (res[2] && res[2].data) {
          setEquipementList(res?.[2]?.data || []);
        }

        if (res[3] && res[3].data) {
          setHelperList(res?.[3]?.data || []);
        }
        // debugger;
      })
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const getFarm = ({ selectedSubDistrict, selectedVillage } = {}) => {
    let param = {
      project_id: team.project_id,
      team_id: team.id,
    };
    if (selectedSubDistrict) {
      param = { ...param, sub_district_id: selectedSubDistrict };
    }
    if (selectedVillage) {
      param = { ...param, village_id: selectedVillage };
    }

    getApi(GET_FARMS, param)
      .then((res) => {
        // let sortedData = res?.data?.sort((a, b) => {
        //   return (
        //     moment(a?.farmer?.[0]?.crop_harvest_date) >
        //     moment(b?.farmer?.[0]?.crop_harvest_date)
        //   );
        // });
        setFarmersListToShow(res?.data);
        getFarmers();
        if (!selectedSubDistrict && !selectedVillage) {
          setFarmersListToShow(res?.data);
        }
      })
      .finally(() => {
        setIsRequesting(false);
      });
  };
  const getFarmers = () => {
    let param = {
      project_id: team.project_id,
    };

    getApi(FARMERS, param)
      .then((res) => {
        setFarmersList(res.data);
      })
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const handleTaskModalClose = () => {
    setFarmersAssignModal(false);
  };

  const handleModalOpen = () => {
    setFarmersAssignModal(true);
  };

  const getSelectableDrivers = (type) => {
    let subTeamDataForUpdate = { ...subTeamsList };
    const teamTypes = Object.keys(subTeamDataForUpdate);
    let selectedDrivers = [];
    teamTypes.map((t) => {
      if (t != type) {
        selectedDrivers = [
          ...selectedDrivers,
          ...(subTeamDataForUpdate[t]
            ?.map((st) => st.driver_id)
            ?.filter((val) => val) || []),
        ];
      }
    });
    return driverList.filter((d) => !selectedDrivers.includes(d.id));
  };

  const getSelectableVehicles = (type) => {
    let subTeamDataForUpdate = { ...subTeamsList };
    const teamTypes = Object.keys(subTeamDataForUpdate);
    let selectedVehicles = [];
    teamTypes.map((t) => {
      if (t != type) {
        selectedVehicles = [
          ...selectedVehicles,
          ...(subTeamDataForUpdate[t]
            ?.map((st) => st.vehicle_id)
            ?.filter((val) => val) || []),
        ];
      }
    });
    return vehiclesList.filter((d) => !selectedVehicles.includes(d.id));
  };

  const getSelectableHelpers = (type) => {
    let subTeamDataForUpdate = { ...subTeamsList };
    const teamTypes = Object.keys(subTeamDataForUpdate);
    let selectedHelpers = [];
    teamTypes.map((t) => {
      if (t != type) {
        selectedHelpers = [
          ...selectedHelpers,
          ...(subTeamDataForUpdate[t]
            ?.map((st) => st.helper_id)
            ?.filter((val) => val) || []),
        ];
      }
    });
    return helperList?.filter((d) => !selectedHelpers.includes(d.id)) || [];
  };

  const getSelectableEquipments = (type, editEntityType) => {
    let subTeamDataForUpdate = { ...subTeamsList };
    const teamTypes = Object.keys(subTeamDataForUpdate);
    let selectedEquipments = [];
    teamTypes.map((t) => {
      if (t != type) {
        selectedEquipments = [
          ...selectedEquipments,
          ...(subTeamDataForUpdate[t]
            ?.map((st) => st.equipment_id)
            ?.filter((val) => val) || []),
        ];
      }
    });

    let eqListForParticularType = [];
    if (type) {
      eqListForParticularType = equipmentsData.filter((equipment) => {
        if (
          equipment &&
          equipment.type &&
          equipment.type.name?.toLowerCase() ==
            type?.replace(/Team/i, "")?.toLowerCase()
        ) {
          return true;
        }
      });
    }
    return eqListForParticularType.filter(
      (d) => !selectedEquipments.includes(d.id)
    );
  };

  const getAssignedFarmers = (type, action) =>
    new Promise((resolve, reject) => {
      if (action == "view") {
        const params = {
          team_id: team.id,
          team_type: type,
          project_id: team.project_id,
        };
        getApi(ASSIGNED_FARMER_TO_SUB_TEAM, params).then(resolve, reject);
      } else {
        const params = {
          village_id: team.village_id,
          assignable_to: type,
          project_id: team.project_id,
        };
        getApi(ASSIGNABLE_FARMER_TO_SUB_TEAM, params).then(resolve, reject);
      }
    });

  const saveFarmersToTeam = () => {
    handleTaskModalClose();
    if (!selectedFarmers.length) return;

    const params = {
      team_id: team.id,
      project_id: team.project_id,
      farmers: selectedFarmers.map((item) => item.id),
    };

    let api = "";

    switch (actionFor) {
      case "rake":
        api = ASSIGN_FARMER_TO_RAKE_TEAM;
        break;
      case "bailer":
        api = ASSIGN_FARMER_TO_BAILER_TEAM;
        break;
      case "trolley":
        break;
      default:
        api = ASSIGN_FARMER_TO_RAKE_TEAM;
    }

    setIsRequesting(true);

    postApi(api, params)
      .then(
        (res) => {},
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const DialogTitle = withStyles(modalStyle)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

  const editSubTeamEntry = (type, idx, team, editEntityType) => {
    setEditedEntityType(type);
    setEditedTeamType(editEntityType);
    let list = [];

    switch (type) {
      case "driver":
        list = getSelectableDrivers(editEntityType);
        break;
      case "helper":
        list = getSelectableHelpers(editEntityType);
        break;
      case "equipment":
        list = getSelectableEquipments(editEntityType, editEntityType);
        break;
      case "vehicle":
        list = getSelectableVehicles(editEntityType);
        break;
      default:
        list = [];
    }

    setSelectedEntity(team[type]);
    setSelectableListForEdit(list);
    setEditedSubTeam(team);
    setEditedEntity(null);
    setIsDialogBoxOpen(true);
  };

  const handleDialogBoxClose = (action) => {
    switch (action) {
      case "updateSubTeam":
        updateSubTeam();
        break;
      default:
        setIsDialogBoxOpen(false);
        setChangeReason("");
    }
  };

  const updateSubTeam = () => {
    setIsRequesting(false);

    const params = {
      sub_teams_id: editedSubTeam.id,
      reassign_reason: changeReason,
    };

    switch (editedEntityType) {
      case "driver":
        params.driver_id = editedEntity?.id;
        break;
      case "helper":
        params.helper_id = editedEntity?.id;
        break;
      case "equipment":
        params.equipment_id = editedEntity?.id;
        break;
      case "vehicle":
        params.vehicle_id = editedEntity?.id;
        break;
      default:
    }

    postApi(REASSIGN_SUB_TEAM, params)
      .then(
        (res) => {},
        (err) => {
          console.log(err);
        }
      )
      .finally(() => {
        setIsDialogBoxOpen(false);
        setIsRequesting(false);
        setChangeReason("");
        const subTeams = { ...subTeamsList };
        const editItemIndex = subTeams[editedTeamType].findIndex(
          (team) =>
            team[`${editedEntityType}_id`] &&
            team[`${editedEntityType}_id`] == selectedEntity?.id
        );
        if (editItemIndex !== -1) {
          subTeams[editedTeamType][editItemIndex][`${editedEntityType}_id`] =
            editedEntity?.id;
          subTeams[editedTeamType][editItemIndex][
            `${editedEntityType}`
          ] = editedEntity;
        }

        setSubTeamsList(subTeams);
      });
  };

  const renderRenameDialog = () => {
    return (
      <Dialog
        open={isDialogBoxOpen}
        onClose={handleDialogBoxClose}
        fullWidth={true}
        // minWidth={"md"}
        aria-labelledby="form-dialog-title"
        className="dialog-box"
      >
        <DialogTitle id="form-dialog-title">Edit Sub Team Entity</DialogTitle>
        <DialogContent dividers>
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="vehicle-type">Choose Option</InputLabel>
            <Select
              labelId="vehicle-type"
              id="vehicle-type-simple-select-outlined"
              name="vehicle_type"
              value={editedEntity?.id || selectedEntity?.id}
              labelWidth={500}
              autoWidth={true}
              onChange={(e) => {
                const obj = selectableListForEdit.find(
                  (obj) => obj.id === e.target.value
                );
                setEditedEntity(obj);
              }}
              label="Choose Option"
            >
              {selectableListForEdit.map((obj, idx) => (
                <MenuItem key={idx} value={obj.id}>
                  {obj.name
                    ? obj.name
                    : `${obj.product_name || obj.registration_number} (${
                        obj.unique_number
                      })`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            autoFocus
            variant="outlined"
            margin="normal"
            fullWidth
            id="reason"
            label="Reason of changing"
            value={changeReason}
            onChange={(e) => setChangeReason(e.target.value)}
            type="text"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDialogBoxClose("close")} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => handleDialogBoxClose("updateSubTeam")}
            color="primary"
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderDialog = () => (
    <Dialog
      onClose={handleTaskModalClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      fullWidth={true}
      fullScreen={true}
      maxWidth={"lg"}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleTaskModalClose}>
        Farmers ({team.name})
      </DialogTitle>
      <DialogContent dividers>
        <Multiselect
          options={farmersListToShow}
          selectedValues={selectedFarmers}
          onSelect={(selectedList) => setSelectedFarmers(selectedList)}
          placeholder="Select Farmers"
          style={multiselectStyle}
          onRemove={(selectedList) => setSelectedFarmers(selectedList)}
          displayValue="name"
        />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          variant="outlined"
          onClick={handleTaskModalClose}
          color="error"
        >
          Cancel
        </Button>
        <Button variant="outlined" onClick={saveFarmersToTeam} color="primary">
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderViewDialog = () => (
    <Dialog
      onClose={() => setViewDialogOpen(false)}
      aria-labelledby="customized-dialog-title"
      open={viewDialogOpen}
      fullWidth={true}
      maxWidth={"sm"}
      className="Dialog-box-2"
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => setViewDialogOpen(false)}
      >
        Farmers ({team.name})
      </DialogTitle>
      <DialogContent dividers style={{ minHeight: 300, overflow: "scroll" }}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Phone Number</TableCell>
                <TableCell>Harvest Date</TableCell>
                <TableCell>Farm Area</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {farmersListToShow.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell component="th" scope="row">
                    {item.name || "--"}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {item.mobile_no || "--"}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {moment(item.crop_harvest_date).format(
                      DATE_FORMATS.DATE_ONLY_FORMAT
                    ) || "--"}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {item.total_area || "--"}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          variant="outlined"
          onClick={() => setViewDialogOpen(false)}
          color="error"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  const renderSubTeams = (items = [], key) => {
    items.sort((a, b) => {
      return a.id - b.id;
    });

    let subTeams = items;
    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Driver</TableCell>
              {key != "rake" && <TableCell>Helper</TableCell>}
              <TableCell>Equipment</TableCell>
              <TableCell>Vehicle</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subTeams?.map((team, idx) => (
              <TableRow key={`${idx}-${team.id}-${team.driver?.name}`}>
                <TableCell>{idx + 1}</TableCell>
                <TableCell>
                  {team.driver?.name || "--"}
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    size="small"
                    onClick={() => {
                      setSelectedEntity(team.driver);
                      editSubTeamEntry("driver", idx, team, key);
                    }}
                  >
                    <EditRounded />
                  </IconButton>
                </TableCell>
                {key != "rake" && (
                  <TableCell>
                    {team.helper?.name || "--"}
                    <IconButton
                      edge="end"
                      aria-label="edit"
                      size="small"
                      onClick={() => {
                        setSelectedEntity(team.helper);
                        editSubTeamEntry("helper", idx, team, key);
                      }}
                    >
                      <EditRounded />
                    </IconButton>
                  </TableCell>
                )}
                <TableCell>
                  {team.equipment?.product_name
                    ? `${team.equipment?.product_name} (${team.equipment?.unique_number})`
                    : "--"}
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    size="small"
                    onClick={() => {
                      setSelectedEntity(team.equipment);
                      editSubTeamEntry("equipment", idx, team, key);
                    }}
                  >
                    <EditRounded />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {team.vehicle?.registration_number
                    ? `${team.vehicle?.registration_number} (${team.vehicle?.unique_number})`
                    : "--"}
                  <IconButton
                    edge="end"
                    aria-label="edit"
                    size="small"
                    onClick={() => {
                      setSelectedEntity(team.vehicle);
                      editSubTeamEntry("vehicle", idx, team, key);
                    }}
                  >
                    <EditRounded />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };
  const handleVillageChange = (e) => {
    setSelectedVillage(e.target.value);
    getFarm({ selectedSubDistrict, selectedVillage: e.target.value });
  };
  const handleSubDistrictChange = (e) => {
    setSelectedSubDistrict(e.target.value);
    getFarm({ selectedSubDistrict: e.target.value, selectedVillage });
  };

  const assignFarmers = (farmerId) => {
    let subTeams = sub_teams.filter(
      (subTeam) => !subTeam?.jobs.some((job) => job.farmer_id == farmerId)
    );
    subTeams.sort((a, b) => {
      return a.id - b.id;
    });
    // debugger;
    setIsRequesting(true);
    postApi(ASSIGN_FARM_TO_SUB_TEAM, {
      team_id: team.id,
      farmers: [farmerId],
      project_id: team.project_id,
      sub_team_id: subTeams[0]?.id,
    })
      .then((res) => {
        // setFarmersList(res.data);
        // setFarmersListToShow(res.data);
        callBackFunction();
      })
      .finally(() => {
        setIsRequesting(false);
      });
  };

  const updateSequenceInFarmerApi = async () => {
    await axios
      .put(`${API_BASE_URL}${updateSequenceInFarmer}`, updateSequence)
      .then((res) => {})
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (updateSequence?.farmId !== 0 && updateSequence?.sequence !== "") {
      updateSequenceInFarmerApi();
    }
  }, [updateSequence]);

  const renderPendingJobs = (items = [], key) => (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="caption table">
        <TableHead>
          <TableRow>
            <TableCell>Sr. No.</TableCell>
            <TableCell>Farmer Name</TableCell>
            <TableCell>Village</TableCell>
            <TableCell>
              Area <small>in acres</small>
            </TableCell>
            <TableCell>Harvest Date</TableCell>
            <TableCell>Contact</TableCell>
            {/* Assign Column */}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items
            ?.filter((item) => {
              if (pendingJobsFilter == 20) {
                return item?.status !== null;
              } else if (pendingJobsFilter == 10) {
                return item?.status == null;
              } else if (pendingJobsFilter == "") {
                return;
              }
            })
            .map((item, key) => {
              const checkIsFarmerAssinged = item.status != null;

              return (
                <TableRow key={key + "-" + item?.id}>
                  <TableCell>{key + 1}</TableCell>
                  <TableCell>{item?.farmer?.[0]?.name || "--"}</TableCell>
                  <TableCell>{item?.village?.name}</TableCell>
                  <TableCell>{item?.area}</TableCell>
                  <TableCell>
                    <div style={{ display: "flex" }}>
                      <span>
                        {moment(item?.farmer?.[0]?.crop_harvest_date).format(
                          "YYYY-MM-DD"
                        )}
                      </span>
                      <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={() => {
                          editHarvestDate();
                          setFarmerId(item?.farmer[0]?.id);
                          setOriginalHarvestDate(
                            moment(item?.farmer[0]?.crop_harvest_date)
                          );
                        }}
                      >
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    </div>
                  </TableCell>
                  <TableCell>{item?.farmer?.[0]?.mobile_no}</TableCell>
                  <TableCell>
                    {/* {item?.farm_status !== "pending" && ( */}
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        setUpdateSequence({
                          farm_id: item?.id,
                          sequence: Object.keys(subTeamsList)?.toString(),
                        });
                        assignFarmers(item?.id);
                      }}
                    >
                      {checkIsFarmerAssinged ? "Assigned" : "Assign"}
                    </Button>
                    {/* )} */}
                    {/* {item?.farm_status === "pending" && (
                    <span style={{ fontWeight: "bold", color: "green" }}>
                      In-Process
                    </span>
                  )} */}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderCurrentJobs = (items = [], team) => {
    let tempJob = [];
    items.map((team) => {
      if (team?.jobs && team?.jobs?.length) {
        const inProgessJos = team?.jobs.filter(
          (job) => job?.is_complete === "false"
        );
        tempJob = [...tempJob, ...inProgessJos];
      }

      return team;
    });
    // farmersListToShow;
    const uniqueJob = [];
    tempJob.forEach((item) => {
      var i = uniqueJob.findIndex((x) => x.id == item.id);
      if (i <= -1) {
        uniqueJob.push(item);
      }
    });
    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Driver</TableCell>
              <TableCell>Equipement</TableCell>
              <TableCell>Vehicle</TableCell>
              <TableCell>Farmer Name</TableCell>
              {/* <TableCell>Village Name</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {uniqueJob &&
              uniqueJob.map((jobItem, index) => {
                const {
                  farmer_id,
                  id,
                  is_complete,
                  project_id,
                  sub_team_id,
                  team_id,
                } = jobItem;
                const { team_village } = team;
                const subTeamData = items.find(
                  (subTeam) => subTeam.id === sub_team_id
                );
                const { equipment = {}, vehicle = {} } = subTeamData || {};
                const vehicleData = vehiclesList.find(
                  (vItem) => vItem?.id === vehicle.id
                );
                const farmerData = farmersList.find(
                  (farmer) => farmer.id === farmer_id
                );
                return (
                  <TableRow key={id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{subTeamData?.driver?.name || "--"}</TableCell>
                    <TableCell>{equipment?.product_name || "--"}</TableCell>
                    <TableCell>{vehicleData?.type?.name || "--"}</TableCell>
                    <TableCell>{farmerData?.name || "--"}</TableCell>
                    {/* <TableCell>{farmerData?.village?.name || "--"}</TableCell> */}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const getCurrentJobs = (items = []) => {
    return (
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>Sr. No.</TableCell>
              <TableCell>Driver</TableCell>
              <TableCell>Equipement</TableCell>
              <TableCell>Vehicle</TableCell>
              <TableCell>Farmer Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items
              ?.filter((item) => item?.status !== null)
              ?.map((item, index) => {
                const sequence = item?.sequence?.split(",");
                const statusKeys = Object.keys(item?.keys);

                let pushedValue = [];

                // for (let i = 0; i < sequence?.length; i++) {
                //   let text = sequence[i] + "_status";

                //   // if(statusKeys?.includes(text)) {
                //   // }
                // }

                return (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    {/* <TableCell>{subTeamData?.driver?.name || "--"}</TableCell>
                  <TableCell>{equipment?.product_name || "--"}</TableCell>
                  <TableCell>{vehicleData?.type?.name || "--"}</TableCell>
                  <TableCell>{farmerData?.name || "--"}</TableCell> */}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    );
    // let farmCurrentJobs = [];
  };

  // getCurrentJobs(farmersListToShow);

  const openAddDistrictDialog = () => (
    <AddDistrictPopUp
      addDistrictPopupOpen={addDistrictPopupOpen}
      setAddDistrictPopupOpen={setAddDistrictPopupOpen}
      projectId={team.project_id}
      sectorOfficerId={teamParams.sector_officer_id}
      teamId={team.id}
      projectList={projectList}
      saveCallack={getAllData}
      sectorOfficerTeamData={sectorOfficerTeamData}
    />
  );

  const resetSelection = (changeType = "") => {
    if (changeType == "teamChange") {
      setSelectedVillage();
      setSelectedSubDistrict();
      return;
    }
    setVillagesList();
    setSubDistrictList();
    setSelectedVillage();
    setSelectedSubDistrict();
  };
  const isFarmerAssigned = (farmerId) => {
    let checkFarmerExist = false;
    let subTeamId = null;

    if (team && team?.sub_teams)
      // team.sub_teams[0].jobs[0].farmer_id
      checkFarmerExist = team?.sub_teams.every((team) =>
        team.jobs.some((job) => job?.farmer_id === farmerId)
      );
    // for (let index = 0; index < team?.sub_teams.length; index++) {
    //   const jobs = team.sub_teams[index]?.jobs;
    //   const id = team.sub_teams[index]?.id;
    //   if (job?.farmer_id === farmerId) {
    //     checkFarmerExist = true;
    //     subTeamId = id;
    //     break;
    //   }
    //   for (let jobsIndex = 0; jobsIndex < jobs.length; jobsIndex++) {
    //     const job = jobs[index];
    //     if (job?.farmer_id === farmerId) {
    //       checkFarmerExist = true;
    //       subTeamId = id;
    //       break;
    //     }
    //   }
    // }
    return { checkFarmerExist, subTeamId };
  };
  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {/* {renderDialog()} */}
          {renderViewDialog()}
          <GridContainer>
            <GridItem xs={6} sm={6} md={6} lg={6}>
              <Card
                style={{
                  minHeight: 250,
                }}
              >
                <CardHeader color="primary" style={{ height: 100 }}>
                  <GridContainer>
                    <GridItem xs={6} sm={3} md={4} lg={3}>
                      <h4 className={classes.cardTitleWhite}>
                        Sub Teams {team?.name ? `(${team?.name})` : ""}
                      </h4>
                    </GridItem>
                    <GridItem xs={6} sm={9} md={8} lg={9}>
                      <GridContainer alignItems="right">
                        <GridItem xs={12} sm={6} md={6}>
                          {sectorOfficerList.length > 0 && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              color="#fff"
                              style={{
                                minWidth: 170,
                                marginRight: 21,
                                height: 70,
                              }}
                            >
                              <InputLabel id="sector-officer-filter-select-outlined-label">
                                Sector officer
                              </InputLabel>
                              <Select
                                labelId="sector-officer-filter-select-outlined-label"
                                id="sector-officer-filter-select-outlined"
                                value={teamParams.sector_officer_id}
                                label="Sector officer"
                                onChange={handleSectorOfficerChange}
                              >
                                {sectorOfficerList &&
                                sectorOfficerList.length ? (
                                  sectorOfficerList.map(
                                    (sectorOfficer, idx) => (
                                      <MenuItem
                                        key={idx}
                                        value={sectorOfficer.user_details.id}
                                      >
                                        {sectorOfficer.user_details.name}
                                      </MenuItem>
                                    )
                                  )
                                ) : (
                                  <MenuItem value={""}>No Option</MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                          {teams.length > 0 && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{
                                minWidth: 170,
                                marginRight: 21,
                                height: 70,
                              }}
                            >
                              <InputLabel id="sector-officer-filter-select-outlined-label">
                                Teams
                              </InputLabel>
                              <Select
                                labelId="sector-officer-filter-select-outlined-label"
                                id="sector-officer-filter-select-outlined"
                                value={selectedTeam?.id}
                                label="Teams"
                                onChange={(e) => {
                                  resetSelection("teamChange");
                                  handleTeamChange(e);
                                }}
                              >
                                {teams && teams.length ? (
                                  teams.map((team, idx) => (
                                    <MenuItem key={idx} value={team.id}>
                                      {team.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem value={""}>No Option</MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </CardHeader>
                <CardBody>
                  {Object.keys(subTeamsList).length ? (
                    Object.keys(subTeamsList).map((key, index) => (
                      <div key={index} style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: 20,
                          }}
                        >
                          <Typography variant="h6" className={classes.title}>
                            {key}(s)
                          </Typography>
                        </div>
                        <GridContainer>
                          {renderSubTeams(subTeamsList[key], key)}
                        </GridContainer>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: 30,
                        fontSize: "17px",
                      }}
                    >
                      No records found.
                    </div>
                  )}
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={6} sm={6} md={6} lg={6}>
              <Card>
                <CardHeader color="primary" style={{ height: 100 }}>
                  <GridContainer alignItems="center">
                    <GridItem xs={6} sm={3} md={4} lg={3}>
                      <AddIcon
                        onClick={() => {
                          if (team && team.id) setAddDistrictPopupOpen(true);
                        }}
                      />
                    </GridItem>
                    <GridItem xs={6} sm={9} md={8} lg={9}>
                      <GridContainer alignItems="center">
                        <GridItem xs={12} sm={6} md={6}>
                          {subDistrictList && subDistrictList.length > 0 && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{
                                minWidth: 170,
                                marginRight: 21,
                                height: 70,
                              }}
                            >
                              <InputLabel id="sub-district-filter-select-outlined-label">
                                Sub District
                              </InputLabel>
                              <Select
                                labelId="sub-district-filter-select-outlined-label"
                                id="sub-district-filter-select-outlined"
                                value={selectedSubDistrict}
                                label="Sub District"
                                onChange={handleSubDistrictChange}
                              >
                                {subDistrictList && subDistrictList.length ? (
                                  subDistrictList.map(
                                    (subDistrictItem, idx) => (
                                      <MenuItem
                                        key={idx}
                                        value={subDistrictItem.id}
                                      >
                                        {subDistrictItem.name}
                                      </MenuItem>
                                    )
                                  )
                                ) : (
                                  <MenuItem value={""}>No Option</MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </GridItem>
                        <GridItem xs={12} sm={6} md={6}>
                          {villageList && villageList.length > 0 && (
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{
                                minWidth: 170,
                                marginRight: 21,
                                height: 70,
                              }}
                            >
                              <InputLabel id="villages-filter-select-outlined-label">
                                Villages
                              </InputLabel>
                              <Select
                                labelId="villages-filter-select-outlined-label"
                                id="villages-filter-select-outlined"
                                value={selectedVillage}
                                label="Villages"
                                onChange={handleVillageChange}
                              >
                                {villageList && villageList.length ? (
                                  villageList.map((villageItem, idx) => (
                                    <MenuItem key={idx} value={villageItem.id}>
                                      {villageItem.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem value={""}>No Option</MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          )}
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </CardHeader>

                <CardBody>
                  <h4 className={classes.jobOverview}>Current Jobs</h4>
                  {sub_teams && sub_teams.length ? (
                    <GridContainer>
                      {renderCurrentJobs(sub_teams, team)}
                    </GridContainer>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: 30,
                        fontSize: "17px",
                      }}
                    >
                      No records found.
                    </div>
                  )}
                </CardBody>

                <CardBody>
                  <div
                    style={{
                      overflowY: "scroll",
                      overflowX: "hidden",
                      height: "70vh",
                      borderBottom: "2px solid gray",
                    }}
                  >
                    <h4 className={classes.jobOverview}>Pending Jobs</h4>

                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        Assign/UnAssign
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-select-small"
                        value={pendingJobsFilter}
                        label="Assign/UnAssign"
                        onChange={(e) => {
                          setPendingJobsFilter(e.target.value);
                        }}
                      >
                        <MenuItem value={10}>Assign</MenuItem>
                        <MenuItem value={20}>Assigned</MenuItem>
                      </Select>
                    </FormControl>

                    {farmersListToShow && farmersListToShow.length > 0 ? (
                      <GridContainer>
                        {/* filteredFarmer */}
                        {renderPendingJobs(farmersListToShow, 1)}
                      </GridContainer>
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          fontWeight: 30,
                          fontSize: "17px",
                        }}
                      >
                        No records found.
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
          {renderRenameDialog()}
          {openAddDistrictDialog()}
          <Loader isLoading={isRequesting} />
        </GridItem>
      </GridContainer>
      <Dialog
        open={openHarvestDateEditModal}
        onClose={() => {
          setOpenHarvestDateEditModal(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Edit Harvest Date</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <DatePicker
              label="Basic example"
              value={originalHarvestDate}
              onChange={(newValue) => {
                setValue(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleClose} autoFocus>
            Agree
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}

const modalStyle = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const multiselectStyle = {
  searchBox: {
    minHeight: "40px",
    marginTop: 19,
    border: "none",
    borderBottom: "1px solid #2b7b56",
  },
};
